<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Users</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-user" />
            Users
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5">
        <CButton color="primary" class="float-right mt-2" @click="showCreateUserModal">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-3 py-3">
        <CRow>
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              :per-page="table.perPage"
              :current-page="table.currentPage"
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div>
              </template>
              <template #cell(index)="data">
                {{ data.index + 1 + ((table.currentPage-1)*10) }}
              </template>
              <template #cell(role)="row">
                <div v-if="row.item.role == 'super_admin'">Super Admin</div>
                <div v-else-if="row.item.role == 'admin'">Admin</div>
                <div v-else>User</div>
              </template>
              <template #cell(created_at)="row">
                {{ $helper.showData(row.value, "longDate") }}
              </template>
              <template #cell(actions)="row">
                <template>
                  <CButton size="sm" color="warning" style="color: white;" @click="showEditUserModal(row.item)" class="btn-icon mr-2 custom-button-action">
                    <CIcon name="cil-pencil" />
                  </CButton> 
                  <CButton size="sm" color="danger" @click="showDeleteUserModal(row.item.id, row.item.email)" class="btn-icon mr-2 custom-button-action">
                    <CIcon name="cil-trash" />
                  </CButton>
                </template>
              </template>
            </b-table>
            <CCardFooter>
              <b-row>
                <b-col md="8" cols="12">
                  <div class="my-2">{{ table.totalViewText }}</div>
                </b-col>
                <b-col md="4" cols="12">
                  <b-pagination class="mb-0" align="right"
                    v-model="table.currentPage"
                    :total-rows="table.totalRows"
                    :per-page="table.perPage"
                  />
                </b-col>
              </b-row>
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

    <CForm>
      <CModal :closeOnBackdrop="false" :show.sync="showCreateEditUserModal" :centered="true">
        <div slot="header"><h5>{{ (createEditUserAction == 'create') ? 'Create' : 'Edit' }} User</h5></div>
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="createEditUser.full_name.feedback"
                label="Full Name"
                label-for="user-fullname"
                :state="createEditUser.full_name.isValid"
              >
                <b-form-input
                  v-model="createEditUser.full_name.value"
                  :state="createEditUser.full_name.isValid"
                  placeholder="Full Name"
                  maxlength="50"
                  id="user-fullname"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="createEditUser.username.feedback"
                label="User Name"
                label-for="user-username"
                :state="createEditUser.username.isValid"
              >
                <b-form-input
                  v-model="createEditUser.username.value"
                  :state="createEditUser.username.isValid"
                  placeholder="User Name"
                  maxlength="50"
                  id="user-username"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                  label="Role"
                  label-for="user-role"
                >
                <b-form-select
                  v-model="createEditUser.role.value"
                  :options="roleOptions"
                  id="user-role"
                ></b-form-select>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="createEditUser.email.feedback"
                label="Email"
                label-for="user-email"
                :state="createEditUser.email.isValid"
              >
                <b-form-input
                  v-model="createEditUser.email.value"
                  :state="createEditUser.email.isValid"
                  placeholder="Email"
                  maxlength="50"
                  id="user-email"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="createEditUser.password.feedback"
                label="Password"
                label-for="user-password"
                :state="createEditUser.password.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="createEditUser.password.value"
                  :state="createEditUser.password.isValid"
                  placeholder="Password"
                  maxlength="50"
                  id="user-password"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="createEditUser.confirmPassword.feedback"
                label="Password (repeat)"
                label-for="user-confirmPassword"
                :state="createEditUser.confirmPassword.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="createEditUser.confirmPassword.value"
                  :state="createEditUser.confirmPassword.isValid"
                  placeholder="Password (repeat)"
                  maxlength="50"
                  id="user-confirmPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
        </div>
        <div slot="footer">
          <CButton color="primary" variant="outline" @click="showCreateEditUserModal = false">Back</CButton>
          <CButton class="ml-2" v-if="createEditUserAction == 'create'" color="primary" type="submit" @click="createUser" :disabled="isLoading.createEditUser">
            <b-spinner small type="grow" v-if="isLoading.createEditUser" /> 
            {{ isLoading.createEditUser ? 'Loading...' : 'Save' }}
          </CButton>
          <CButton class="ml-2" v-else color="primary" type="submit" @click="editUser" :disabled="isLoading.createEditUser">
            <b-spinner small type="grow" v-if="isLoading.createEditUser" /> 
            {{ isLoading.createEditUser ? 'Loading...' : 'Save' }}
          </CButton>
        </div>
      </CModal>
    </CForm>

    <CModal :closeOnBackdrop="false" :show.sync="showingDeleteUserModal" :centered="true">
      <div slot="header"><h5>Confirm Delete User</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Are you sure you want to delete the following user?
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol col="4">
            ID
          </CCol>
          <CCol col="8">
            : {{ deleteUser.id }}
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol col="4">
            Email
          </CCol>
          <CCol col="8">
            : {{ deleteUser.email }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" variant="outline" @click="showingDeleteUserModal = false">Cancel</CButton>
        <CButton class="ml-2" color="danger" type="submit" @click="confirmDeleteUser" :disabled="isLoading.deleteUser">
          <b-spinner small type="grow" v-if="isLoading.deleteUser" /> 
          {{ isLoading.deleteUser ? 'Loading...' : 'Delete' }}
        </CButton>
      </div>
    </CModal>

  </CContainer>
</template>

<script>
export default {
  name: 'Users',
  data() {
    return {
      showingDeleteUserModal: false,
      deleteUser: {
        id: '0',
        email: "",
      },
      isLoading: {
        createEditUser: false,
        deleteUser: false,
      },
      roleOptions: [
        {value: "super_admin", text: "Super Admin"},
        {value: "admin", text: "Admin"},
        {value: "user", text: "User"}
      ],
      showCreateEditUserModal: false,
      createEditUserAction: 'create',
      editUserLockJobCode: false,
      selectedUserId: 0,
      createEditUser: {
        full_name: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "full_name"
        },
        username: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "username"
        },
        role: {
          value: 'user',
          isRequired: true,
          payloadKey: "role"
        },
        email: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "email"
        },
        password: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "password"
        },
        confirmPassword: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "confirmPassword"
        },
      },
      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        totalViewText: '',
        isLoaded: true,
        fields: [
          {key: "index", label: "No.", sortable: false},
          {key: "full_name", label: "Full Name", sortable: true},
          {key: "username", label: "User Name", sortable: true},
          {key: "email", label: "Email Address", sortable: true},
          {key: "role", label: "Role", sortable: true},
          { key: "actions", label: "Actions", sortable: false, class:"custom-column-action-user" }
        ],

        items: [],

        filterType: "id",
        filterOptions: [
          { value: "email", text: "Email" },
          { value: "created_at", text: "Created At" },
        ],
        filterValue: "",
        filterValueIsLockedOptions: [
          { value: "true", text: "Y" },
          { value: "false", text: "N" },
        ],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      recalculate() {
        let pg = this.table.currentPage - 1

        let prev = pg * this.table.perPage + 1
        let limit = pg * this.table.perPage + this.table.perPage
        if (limit > this.table.totalRows) limit = this.table.totalRows
        if (this.table.totalRows == 0) prev = 0
        this.table.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.table.totalRows + " entri"
      }
    }
  },
  computed: {
    userId() {
      return localStorage.getItem(this.$userIdKeyword)
    },
    totalRows() {
      return this.table.totalRows;
    },
    currentPage() {
      return this.table.currentPage;
    }
  },
  watch: {

    totalRows(newVal) {
      this.recalculate()
    },

    currentPage(newVal) {
      this.recalculate()
    },

  },
  methods: {

    showCreateUserModal(event) {
      event.preventDefault()

      this.createEditUserAction = 'create'
      this.resetCreateEditUserFields()
      this.showCreateEditUserModal = true
    },

    showEditUserModal(user) {
      this.resetCreateEditUserFields()
      this.selectedUserId = user.id
      this.createEditUserAction = 'edit'
      this.createEditUser.email.value = user.email
      this.createEditUser.full_name.value = user.full_name
      this.createEditUser.username.value = user.username
      this.createEditUser.role.value = user.role
      this.showCreateEditUserModal = true
    },

    resetCreateEditUserFields() {
      this.selectedUserId = 0
      this.createEditUser.full_name.value = ''
      this.createEditUser.username.value = ''
      this.createEditUser.role.value = 'user'
      this.createEditUser.email.value = ''
      this.createEditUser.password.value = ''
      this.createEditUser.confirmPassword.value = ''
      for(const [key, data] of Object.entries(this.createEditUser)){
        data.isValid = null
      }
    },

    // editUserPassword(event) {
    //   event.preventDefault()

    //   this.isLoading.editPassword = true
    //   let isFormValid = true
    //   for(const [key, data] of Object.entries(this.editPasswordUser)){
    //     // Password Minimal 8 karakter, mengandung angka (0 - 9), huruf besar, huruf kecil, dan karakter khusus (+_)(*&^%$#@!~`[]\;‘,./<>?:“{}|)
    //     if (key == 'newPassword') {
    //       if (data.isRequired && this.$helper.isEmpty(data.value)) {
    //         data.feedback = "This input is required."
    //         isFormValid = false
    //         data.isValid = false
    //       } else if (data.value.length < 8) {
    //         data.feedback = "Password should contain a minimal 8 characters."
    //         isFormValid = false
    //         data.isValid = false
    //       } else if (!this.$helper.containsSmallLetter(data.value) || !this.$helper.containsCapitalLetter(data.value)) {
    //         data.feedback = "Password should contain small [a-z] and capital [A-Z] letter."
    //         isFormValid = false
    //         data.isValid = false
    //       } else if (!this.$helper.containsNumber(data.value)) {
    //         data.feedback = "Password should contain number [0-9]."
    //         isFormValid = false
    //         data.isValid = false
    //       } else if (!this.$helper.containsSpecialCharacter(data.value)) {
    //         data.feedback = "Password should contain special character [ `!@#$%^&*()_+-=[]{};':\"|,.<>/?~ ]."
    //         isFormValid = false
    //         data.isValid = false
    //       } else{
    //         data.isValid = null
    //       }
    //     } else if (key == 'confirmNewPassword') {
    //       // Repeat Password on confirm password field
    //       if (data.isRequired && this.$helper.isEmpty(data.value)) {
    //         data.feedback = "This input is required."
    //         isFormValid = false
    //         data.isValid = false
    //       } else if (data.value != this.editPasswordUser.newPassword.value) {
    //         data.feedback = "Please repeat the same password."
    //         isFormValid = false
    //         data.isValid = false
    //       } else{
    //         data.isValid = null
    //       }
    //     } else{
    //       // The rest of the field
    //       if (data.isRequired && this.$helper.isEmpty(data.value)) {
    //         isFormValid = false
    //         data.isValid = false
    //       } else{
    //         data.isValid = null
    //       }
    //     }
    //   }

    //   if (isFormValid) {
    //     let postUrl = '/users'
    //     this.isSubmitting = true
    //     let obj = {
    //       id: this.selectedUserId,
    //       full_name: null,
    //       username: null,
    //       email: this.createEditUser.email.value,
    //       password: this.editPasswordUser.currentPassword.value,
    //       role: this.createEditUser.role.value,
    //       updator_id: localStorage.getItem("cctvUserId")
    //     }
       
    //     this.$axios.put(postUrl, obj).then(response => {
    //       if(response.status == 200){
    //         this.$helper.toastSuccess(this, "Change Password Berhasil! " + (response.data.reason ? response.data.reason : ""))
    //         this.showEditPasswordModal = false
    //       } else{
    //         this.$helper.toastError(this, "Change Password Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Change Password Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Change Password Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.isLoading.editPassword = false
    //     })
    //   } else{
    //     this.isLoading.editPassword = false
    //   }
    // },

    editUser(event) {
      event.preventDefault()

      this.isLoading.createEditUser = true
      let isFormValid = true

      let full_name = this.createEditUser.full_name
      if (full_name.isRequired && this.$helper.isEmpty(full_name.value)) {
        full_name.feedback = "This input is required."
        isFormValid = false
        full_name.isValid = false
      } else{
        full_name.isValid = null
      }

      let username = this.createEditUser.username
      if (username.isRequired && this.$helper.isEmpty(username.value)) {
        username.feedback = "This input is required."
        isFormValid = false
        username.isValid = false
      } else{
        username.isValid = null
      }

      let email = this.createEditUser.email
      if (email.isRequired && this.$helper.isEmpty(email.value)) {
        email.feedback = "This input is required."
        isFormValid = false
        email.isValid = false
      } else{
        email.isValid = null
      }

      let password = this.createEditUser.password
      if (password.isRequired && this.$helper.isEmpty(password.value)) {
        password.feedback = "This input is required."
        isFormValid = false
        password.isValid = false
      } else if (password.value.length < 6) {
        password.feedback = "Password should contain a minimum of 6 characters."
        isFormValid = false
        password.isValid = false
      // } else if (!this.$helper.containsSmallLetter(password.value) || !this.$helper.containsCapitalLetter(password.value)) {
      //   password.feedback = "Password should contain small [a-z] and capital [A-Z] letter."
      //   isFormValid = false
      //   password.isValid = false
      // } else if (!this.$helper.containsNumber(password.value)) {
      //   password.feedback = "Password should contain number [0-9]."
      //   isFormValid = false
      //   password.isValid = false
      // } else if (!this.$helper.containsSpecialCharacter(password.value)) {
      //   password.feedback = "Password should contain special character [ `!@#$%^&*()_+-=[]{};':\"|,.<>/?~ ]."
      //   isFormValid = false
      //   password.isValid = false
      } else{
        password.isValid = null
      }

      let confirmPassword = this.createEditUser.confirmPassword
      if (confirmPassword.isRequired && this.$helper.isEmpty(confirmPassword.value)) {
        confirmPassword.feedback = "This input is required."
        isFormValid = false
        confirmPassword.isValid = false
      } else if (password.value != confirmPassword.value) {
        confirmPassword.feedback = "Please repeat the same password."
        isFormValid = false
        confirmPassword.isValid = false
      } else{
        confirmPassword.isValid = null
      }

      if (isFormValid) {
        // URL builder
        let putUrl = "/users"
        let obj = {
          id: this.selectedUserId,
          full_name: this.createEditUser.full_name.value,
          username: this.createEditUser.username.value,
          email: this.createEditUser.email.value,
          password: this.createEditUser.password.value,
          role: this.createEditUser.role.value,
        }
  
        this.$axios.put(putUrl, obj).then(response => {
          if(response.status == 200){
            if (response.data.success){
              this.$helper.toastSuccess(this, "Edit User Berhasil! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
              this.resetCreateEditUserFields()
              this.showCreateEditUserModal = false
            } else{
              this.$helper.toastError(this, "Edit User Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
            }
          }
          else{
            this.$helper.toastError(this, "Edit User Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Edit User Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Edit User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isLoading.createEditUser = false
        })
      } else{
        this.isLoading.createEditUser = false
      }
    },

    confirmDeleteUser() {

      this.isLoading.deleteUser = true
      // URL builder
      let deleteUrl = "/users/" + this.deleteUser.id

      this.$axios.delete(deleteUrl).then(response => {
        if(response.status == 200){
          if (response.data.success){
            this.$helper.toastSuccess(this, "Delete User Berhasil! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
            this.showingDeleteUserModal = false
            this.getTableItems()
          } else{
            this.$helper.toastError(this, "Delete User Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        }
        else{
          this.$helper.toastError(this, "Delete User Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Delete User Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Delete User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.deleteUser = false
      })
    },

    createUser(event) {
      event.preventDefault()

      this.isLoading.createEditUser = true
      let isFormValid = true

      let full_name = this.createEditUser.full_name
      if (full_name.isRequired && this.$helper.isEmpty(full_name.value)) {
        full_name.feedback = "This input is required."
        isFormValid = false
        full_name.isValid = false
      } else{
        full_name.isValid = null
      }

      let username = this.createEditUser.username
      if (username.isRequired && this.$helper.isEmpty(username.value)) {
        username.feedback = "This input is required."
        isFormValid = false
        username.isValid = false
      } else{
        username.isValid = null
      }

      let email = this.createEditUser.email
      if (email.isRequired && this.$helper.isEmpty(email.value)) {
        email.feedback = "This input is required."
        isFormValid = false
        email.isValid = false
      } else{
        email.isValid = null
      }

      let password = this.createEditUser.password
      if (password.isRequired && this.$helper.isEmpty(password.value)) {
        password.feedback = "This input is required."
        isFormValid = false
        password.isValid = false
      } else if (password.value.length < 6) {
        password.feedback = "Password should contain a minimum of 6 characters."
        isFormValid = false
        password.isValid = false
      // } else if (!this.$helper.containsSmallLetter(password.value) || !this.$helper.containsCapitalLetter(password.value)) {
      //   password.feedback = "Password should contain small [a-z] and capital [A-Z] letter."
      //   isFormValid = false
      //   password.isValid = false
      // } else if (!this.$helper.containsNumber(password.value)) {
      //   password.feedback = "Password should contain number [0-9]."
      //   isFormValid = false
      //   password.isValid = false
      // } else if (!this.$helper.containsSpecialCharacter(password.value)) {
      //   password.feedback = "Password should contain special character [ `!@#$%^&*()_+-=[]{};':\"|,.<>/?~ ]."
      //   isFormValid = false
      //   password.isValid = false
      } else{
        password.isValid = null
      }

      let confirmPassword = this.createEditUser.confirmPassword
      if (confirmPassword.isRequired && this.$helper.isEmpty(confirmPassword.value)) {
        confirmPassword.feedback = "This input is required."
        isFormValid = false
        confirmPassword.isValid = false
      } else if (password.value != confirmPassword.value) {
        confirmPassword.feedback = "Please repeat the same password."
        isFormValid = false
        confirmPassword.isValid = false
      } else{
        confirmPassword.isValid = null
      }

      if (isFormValid) {
        // URL builder
        let postUrl = "/users"
        let obj = {
          full_name: this.createEditUser.full_name.value,
          username: this.createEditUser.username.value,
          email: this.createEditUser.email.value,
          password: this.createEditUser.password.value,
          role: this.createEditUser.role.value,
        }

        this.$axios.post(postUrl, obj).then(response => {
          if(response.status == 200){
            if (response.data.success){
              this.$helper.toastSuccess(this, "Create User Berhasil! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
              this.resetCreateEditUserFields()
              this.showCreateEditUserModal = false
              this.getTableItems()
            } else{
              this.$helper.toastError(this, "Create User Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
            }
          }
          else{
            this.$helper.toastError(this, "Create User Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Create User Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Create User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isLoading.createEditUser = false
        })
      } else{
        this.isLoading.createEditUser = false
      }
    },

    showDeleteUserModal(id, email) {
      this.deleteUser.id = id
      this.deleteUser.email = email
      this.showingDeleteUserModal = true
    },

    onChangeFilterType() {
      if (this.table.filterType == "isLocked") {
        this.table.filterValue = "true"
      } else{
        this.table.filterValue = null
      }
    },

    getTableItems() {
      this.table.isLoaded = false
      this.table.items = []
      // URL builder
      let getUrl = "/users"
      let params = {}

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.table.items = response.data.data
          this.table.totalRows = response.data.data.length
          this.table.totalPages = response.data.data.length % this.table.perPage
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },
  },

  created(){
    this.getTableItems()
  },
}
</script>

<style>

</style>
